import React, { useState, useEffect } from 'react';
import Preloader from '../../../../general/Preloader'

const UserIndex = (props) => {
    const [isLoaded, setIsLoaded] = useState(false);
    const [isLoadedCode, setIsLoadedCode] = useState(false);

    const token = document.querySelector("[name='csrf-token']").content;
    const [messageContent, setMessageContent] = useState({ 
        valid: false,
        type: "",
        message: "El correo electrónico o la contraseña ingresados son inválidos. Por favor, verifica tus datos e intenta nuevamente."
    });

    const [form, setForm] = useState({ 
        code: "",
        ...props.user
    });

    const handleChange = (e) => {
        setForm({ ...form, [e.target.name]: e.target.value })
    }

    const handleSubmit = e => {
        e.preventDefault();
    };

    const validationForm = () => {
        if (form.code != ""
        ) {
            setMessageContent({ 
                valid: false, 
                type: "danger",
                message: "El campo del código es obligatorio. Por favor, ingresa el código para continuar." 
            })
            return true
        }else{
            setMessageContent({ 
                valid: true, 
                type: "danger",
                message: "El campo del código es obligatorio. Por favor, ingresa el código para continuar." 
            })
            return false
        }
    }

    const handleClickCode = () => {
        if(validationForm()){
            setIsLoaded(true);

            fetch(`/api/v1/validate_code_user`, {
                method: 'POST', // or 'PUT'
                body: JSON.stringify(form), // data can be `string` or {object}!
                headers: {
                    "X-CSRF-Token": token,
                    "authorization": "98a2425c7cd22d4dad50",
                    "Content-Type": "application/json"
                }
            })
    
            .then(res => res.json())
            .catch(error => console.error("Error:", error))
            .then(data => {
                console.log("data", data);

                if(data.type == "success"){
                    props.toogleTab("user_form_update")
                    setIsLoaded(false);
                }else{
                    setIsLoaded(false);
                    setMessageContent(data)
                }
            });
        }
    }

    const handleClick = () => {
        setIsLoaded(true);

        fetch(`/api/v1/restore_password`, {
            method: 'POST', // or 'PUT'
            body: JSON.stringify(props.user), // data can be `string` or {object}!
            headers: {
                "X-CSRF-Token": token,
                "authorization": "98a2425c7cd22d4dad50",
                "Content-Type": "application/json"
            }
        })

        .then(res => res.json())
        .catch(error => console.error("Error:", error))
        .then(data => {
            console.log("data", data);
            
            if(data.valid){ 
                setIsLoaded(false);
                setMessageContent(data)
            }
        });
    }
    
    return (
        <React.Fragment>
            <div className="row">
                <div className="col-md-12 text-center mb-3">
                    <h3 className='mb-0 text-primary'>{props.user.name}</h3>
                </div>

                <div className="col-md-12 text-center">
                    <div className="alert alert-primary text-white text-center" role="alert">
                        Para enviarte el código de validación, necesitamos tu confirmación. Haz clic en el siguiente botón y recibirás el código en <b>{props.user.email}</b>. Si el correo es incorrecto, verifica y corrige tu dirección antes de continuar.
                    </div>
                </div>

                {!isLoaded ? (
                    <React.Fragment>
                        {messageContent.valid && (
                            <div className="col-md-12 mt-3">
                                <form onSubmit={handleSubmit}>
                                    <div className="input-group is-invalid">
                                        <div className="custom-file">
                                            <input 
                                                className={`form form-control ${!messageContent.valid && form.code == "" ? "error-class" : ""}`}
                                                type="text" 
                                                name="code" 
                                                value={form.code}
                                                onChange={handleChange}
                                                placeholder="Codigo"
                                                disabled={isLoaded}
                                            />
                                        </div>
                                        <div className="input-group-append">
                                            <button 
                                                className="btn btn-primary" 
                                                disabled={isLoaded} 
                                                onClick={() => handleClickCode()} 
                                                type="button"
                                            >
                                                {isLoaded ? "Aplicando" : "Aplicar"}
                                            </button>
                                        </div>
                                    </div>
                                </form>

                                <div className={`alert alert-${messageContent.type} ${messageContent.type == "danger" ? "text-white" : "text-dark"} text-center mt-3`} role="alert">
                                    {messageContent.message}
                                </div>
                            </div>    
                        )}
                    </React.Fragment>
                ) : (
                    <div className="text-center">
                        <Preloader/>
                    </div>
                )}

                <div className="col-md-12">
                    <hr />
                </div>
                
                <div className="col-md-12 text-center">

                    {!messageContent.valid && (
                        <button
                            className='btn btn-primary text-white mr-2'
                            onClick={handleClick}
                            disabled={isLoaded}
                        >
                            {isLoaded ? "Enviado código..." : "Enviarme instrucción"}
                        </button>
                    )}

                    <button
                        className='btn btn-light text-black'
                        onClick={() => props.toogleTab("email")}
                    >
                        Volver
                    </button>
                </div>

            </div>
        </React.Fragment>
    );
}


export default UserIndex;

